function App() {
  const maintenance = true; // muda para false depois

  if (maintenance) {
    return (
      <div style={{ textAlign: 'center', marginTop: '20%' }}>
        <h1>🚧 Site em manutenção</h1>
        <p>Voltamos em breve.</p>
      </div>
    );
  }

  return (
    <div>
      {/* teu site normal */}
    </div>
  );
}

export default App;